import { useState } from "react";
import Icon from "../../components/shared/Icon";
import { useAuth } from "../../context/AuthContext";

export default function SuperAdminLogin({ onLogin, goBack }) {
  const [email, setEmail] = useState("");
  const [pass, setPass]   = useState("");
  const [showPass, setShowPass] = useState(false);
  const { loginSuperAdmin, loading, error, setError } = useAuth();

  const handleLogin = async () => {
    if (!email || !pass) { setError("Enter email and password."); return; }
    setError(null);
    const ok = await loginSuperAdmin(email, pass);
    if (ok) onLogin();
  };

  return (
    <div style={{ minHeight:"100vh", display:"flex", fontFamily:"'Segoe UI',system-ui,sans-serif" }}>
      <div style={{ width:"42%", background:"linear-gradient(160deg,#0d1b3e 0%,#1a2f6b 50%,#0d4a8f 100%)", display:"flex", flexDirection:"column", alignItems:"center", justifyContent:"center", padding:48, position:"relative", overflow:"hidden" }}>
        <div style={{ position:"absolute", width:300, height:300, borderRadius:"50%", border:"1px solid rgba(255,255,255,0.07)", top:-80, left:-80 }} />
        <div style={{ position:"relative", zIndex:1, textAlign:"center" }}>
          <div style={{ width:88, height:88, borderRadius:22, background:"linear-gradient(135deg,#f59e0b,#ef4444)", display:"flex", alignItems:"center", justifyContent:"center", margin:"0 auto 24px", boxShadow:"0 12px 40px rgba(245,158,11,0.4)" }}>
            <Icon name="shield" size={44} color="#fff" />
          </div>
          <h2 style={{ color:"#fff", fontSize:26, fontWeight:800, margin:"0 0 8px" }}>Super Admin</h2>
          <p style={{ color:"rgba(255,255,255,0.55)", fontSize:14, margin:"0 0 36px" }}>Ap IT Services Control Panel</p>
          {[["Manage All Admins","Create, edit, deactivate admin accounts"],["Control Permissions","Set access rights per admin"],["Society Overview","Monitor all registered societies"]].map(([t,d]) => (
            <div key={t} style={{ display:"flex", gap:10, marginBottom:16, textAlign:"left" }}>
              <div style={{ width:26, height:26, borderRadius:7, background:"rgba(245,158,11,0.2)", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, marginTop:2 }}><Icon name="check" size={13} color="#f59e0b" /></div>
              <div><div style={{ color:"#fff", fontSize:13, fontWeight:600 }}>{t}</div><div style={{ color:"rgba(255,255,255,0.45)", fontSize:12, marginTop:2 }}>{d}</div></div>
            </div>
          ))}
        </div>
      </div>
      <div style={{ flex:1, display:"flex", alignItems:"center", justifyContent:"center", background:"#f8fafc", padding:40 }}>
        <div style={{ width:"100%", maxWidth:400 }}>
          <h2 style={{ margin:"0 0 4px", fontSize:24, fontWeight:800, color:"#1a2744" }}>Super Admin Login</h2>
          <p style={{ margin:"0 0 28px", fontSize:13, color:"#78909c" }}>Sign in to manage your admin accounts</p>
          <div style={{ marginBottom:16 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#546e7a", marginBottom:5, textTransform:"uppercase" }}>Email</label>
            <input value={email} onChange={e=>setEmail(e.target.value)} type="email" placeholder="admin@example.com"
              onKeyDown={e=>e.key==="Enter"&&handleLogin()}
              style={{ width:"100%", padding:"11px 12px", border:"1.5px solid #e0e0e0", borderRadius:9, fontSize:14, outline:"none", boxSizing:"border-box" }} />
          </div>
          <div style={{ marginBottom:22 }}>
            <label style={{ display:"block", fontSize:11, fontWeight:700, color:"#546e7a", marginBottom:5, textTransform:"uppercase" }}>Password</label>
            <div style={{ position:"relative" }}>
              <input type={showPass?"text":"password"} value={pass} onChange={e=>setPass(e.target.value)} placeholder="••••••••"
                onKeyDown={e=>e.key==="Enter"&&handleLogin()}
                style={{ width:"100%", padding:"11px 38px 11px 12px", border:"1.5px solid #e0e0e0", borderRadius:9, fontSize:14, outline:"none", boxSizing:"border-box" }} />
              <button onClick={()=>setShowPass(!showPass)} style={{ position:"absolute", right:11, top:"50%", transform:"translateY(-50%)", background:"none", border:"none", cursor:"pointer", color:"#90a4ae", padding:0 }}><Icon name={showPass?"eyeOff":"eye"} size={15} /></button>
            </div>
          </div>
          {error && <div style={{ background:"#fce8e6", color:"#c62828", padding:"10px 14px", borderRadius:8, fontSize:13, marginBottom:16 }}>{error}</div>}
          <button onClick={handleLogin} disabled={loading}
            style={{ width:"100%", padding:"13px", background:loading?"#ccc":"linear-gradient(135deg,#f59e0b,#ef4444)", border:"none", borderRadius:10, color:"#fff", fontSize:15, fontWeight:700, cursor:loading?"not-allowed":"pointer" }}>
            {loading ? "Signing in…" : "Sign In as Super Admin"}
          </button>
          <button onClick={goBack} style={{ width:"100%", padding:"11px", marginTop:12, background:"none", border:"1.5px solid #e0e0e0", borderRadius:10, color:"#546e7a", fontSize:14, cursor:"pointer" }}>← Back</button>
        </div>
      </div>
    </div>
  );
}
